module.exports = __webpack_public_path__ + "static/unitedNations-a3d7dfe1a5c6d91a67fca3314c184a19.svg";